import { render, staticRenderFns } from "./group-bulk-email-composer.vue?vue&type=template&id=6c4d4f9a&scoped=true"
import script from "./group-bulk-email-composer.vue?vue&type=script&lang=js"
export * from "./group-bulk-email-composer.vue?vue&type=script&lang=js"
import style0 from "./group-bulk-email-composer.vue?vue&type=style&index=0&id=6c4d4f9a&prod&lang=scss&scoped=true"
import style1 from "./group-bulk-email-composer.vue?vue&type=style&index=1&id=6c4d4f9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4d4f9a",
  null
  
)

export default component.exports